exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-color[data-v-7bc3c4d2]{color:var(--systemMainColor)}", ""]);

// exports
